import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translator } from 'mage-i18n';
import { SpacerVertical } from '@klarna/bubble-ui';

import SummarySection from './SummarySection';
import SummaryBankAccounts from '../pages/ApplicationOverview/SummaryBankAccounts';

const tPrefix = 'products-fe.containers.payouts_summary';

const BankAccountsSummary = ({ t, onEdit, country }) => (
  <SummarySection title={t(`${tPrefix}.title`)} onEdit={onEdit}>
    <SummaryBankAccounts
      type="defaultBankAccounts"
      noElementsTKey={`${tPrefix}.default_bank_accounts.no_elements`}
      showCannotEditDisclaimer={country === 'US'}
      hideTitle={country === 'US'}
    />
    {country !== 'US' && (
      <>
        <SpacerVertical spaceToken="space/150" />
        <SummaryBankAccounts
          type="additionalBankAccounts"
          noElementsTKey={`${tPrefix}.additional_bank_accounts.no_elements`}
        />
      </>
    )}
  </SummarySection>
);

BankAccountsSummary.propTypes = {
  country: PropTypes.string,
  t: PropTypes.func,
  onEdit: PropTypes.func,
};

export default connect(state => ({ t: translator(state) }))(BankAccountsSummary);
